
import CyanPageWrapper, {
  defineComponent,
  IonPage,
  store
} from "@/components/CyanPageWrapper.vue";
import CentroPicker from "@/components/CentroPicker.vue";
import { territorios } from '@/modules/cyanRegions'
import unreact from "@/modules/unreact";

export default defineComponent({
  name: "PuntoPickCentro",
  components: {
    CentroPicker,
    IonPage,
    CyanPageWrapper,
  },
  computed: {
    seed() {
      return unreact((this as any).$route.params.seedPC+'') || ''
    }, 

    ambito() {
      if (this.seed in territorios) {
        const m = territorios[(this as any).seed];
				return  m.nombre + ', ' + m.nombrePadre;
      }
      return '';
			
    },
    title() {
			if (this.ambito) {
				return 'Elegir centro (' + this.ambito + ')';
			}
			return 'Elegir centro';
		},
		userLevel() {
      return store.state.userData.nivel || '';
    },
		backRoute() {
			return ((this as any).userLevel.length == 6) ? '/home' : '/puntoPickMpio/' + (this.seed as any).substr(0,4);
		},

  },
  methods: {},
});
